import { useCallback, useMemo } from 'react';
import { dayTheme, nightTheme } from '../theme';
const theme = {
    day: dayTheme,
    night: nightTheme,
};
export const useTheme = ({ mode = 'day', type }) => {
    const config = useMemo(() => {
        return theme[mode][type];
    }, [mode, type]);
    const bind = useCallback(() => {
        return Object.assign(Object.assign({}, config), { dpr: window.devicePixelRatio });
    }, [config]);
    return {
        bind,
    };
};
